import { useCallback } from 'react';
import { useFlowView } from '@/components/Recipe/FlowContext';
import { useWorkflowStore } from '@/state/workflow.state';
import { markRenderedPicture, type MarkedPicture } from './markRenderedPicture';
import type { OutputId } from 'web';

/**
 * Renders a node to PNG and marks it. Resolves undefined when there is no node or the render fails.
 * When the workflow has no id yet, resolves the local picture without marking it.
 */
export function useMarkedNodeRender(
  nodeId: string | undefined,
): (target?: { outputId?: OutputId; generationIndex?: number }) => Promise<MarkedPicture | undefined> {
  const flowView = useFlowView();
  const workflowId = useWorkflowStore((state) => state.recipe?.id);

  return useCallback(
    async (target) => {
      if (!nodeId) return undefined;
      const dataUrl = flowView.renderNodeImage(nodeId, target?.outputId, target?.generationIndex);
      if (!dataUrl) return undefined;
      if (!workflowId) return { url: dataUrl };
      return markRenderedPicture({ workflowId, nodeId, dataUrl });
    },
    [flowView, nodeId, workflowId],
  );
}
